module.exports = __webpack_public_path__ + "static/assets/3367a2e5f6357f87d291a31758e14e15.png";